/**
 * названия  для точек установкиc
 */
export const instalationPointsNames = {
    INSTALATION_POINT_TYPE: 'pc_sensor_ipoints_layer',
    GROUP_NAME: 'Instalation points',
};
